<template>
	<div class="main" v-loading.fullscreen="isLoad" router element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb class="bnone">
			<el-breadcrumb-item>系统设置</el-breadcrumb-item>
			<el-breadcrumb-item>短信管理</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form ref="form" label-position="right" :model="item" label-width="auto" show-message inline-message
			status-icon>
			<el-divider content-position="left">短信</el-divider>
			<el-form-item label="Appid">
				<el-input v-model="item.smsAppid" placeholder="请输入Appid"></el-input>
			</el-form-item>
			<el-form-item label="秘钥">
				<el-input v-model="item.smsKey" placeholder="请输入秘钥"></el-input>
			</el-form-item>
			<el-form-item label="签名">
				<el-input v-model="item.smsSign" placeholder="请输入签名"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
			}
		},
		created() {
			this.loadItem()
		},
		methods: {
			loadItem() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.get('/store/setting/sms').then(res => {
					this.isLoad = !this.isLoad
					if (res.data.length) {
						this.item = res.data[0]
					}
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			submit() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.post('/store/setting/smsEdit', this.item).then(res => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '保存成功'
					});
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			}
		}
	}
</script>
<style>
</style>
